// extracted by mini-css-extract-plugin
module.exports = {"mhJh5":"mhJh5_mhJh5__Gocdj"};